export let empty3DJsonData = {
  annotation: {
    invalidated: false,
    highlighted: false,
    metadata: {
      toolName: "RectangleROI",
      viewPlaneNormal: [0, 0, -1],
      viewUp: [0, -1, 0],
      referencedImageId: "",
    },
    data: {
      label: "",
      handles: {
        points: [
          [0, 0, 0],
          [0, 0, 0],
          [0, 0, 0],
          [0, 0, 0],
        ],
        textBox: {},
        activeHandleIndex: null,
      },
      cachedStats: {},
    },
    annotationUID: "",
    isLocked: false,
    isVisible: true,
  },
};

export const getUpdatedJson = (url, points, uid) => {

  const updateUrl = url.startsWith("wadouri")
            ? url.replace("wadouri", "dicomweb")
            : url;

  let updatedJson = {
    annotation: {
      invalidated: false,
      highlighted: false,
      metadata: {
        toolName: "RectangleROI",
        viewPlaneNormal: [0, 0, -1],
        viewUp: [0, -1, 0],
        referencedImageId: updateUrl,
      },
      data: {
        label: "",
        handles: {
          points: points,
          textBox: {},
          activeHandleIndex: null,
        },
        cachedStats: {},
      },
      annotationUID: uid,
      isLocked: false,
      isVisible: true,
    }
  };
  return updatedJson;
};

export const getAllFourCoordinates = (data) => {
  let topLeftX = data.start.x;
  let topLeftY = data.start.y;
  let bottomRightX = data.end.x;
  let bottomRightY = data.end.y;

  let bottomLeftX = Math.min(topLeftX, bottomRightX);
  let bottomLeftY = Math.max(topLeftY, bottomRightY);
  let topRightX = Math.max(bottomRightX, topLeftX);
  let topRightY = Math.min(topLeftY, bottomRightY);

  let allFourCoordinates = [];
  allFourCoordinates.push([topLeftX, topLeftY, 0.0]);
  allFourCoordinates.push([topRightX, topRightY, 0.0]);
  allFourCoordinates.push([bottomLeftX, bottomLeftY, 0.0]);
  allFourCoordinates.push([bottomRightX, bottomRightY, 0.0]);

  return allFourCoordinates;
};

export const savingBoundingBoxJsonData = (points, uid) => {
  let savingJson = {
    start: {
      x: points[0][0],
      y: points[0][1],
      z: points[0][2],
    },
    end: {
      x: points[3][0],
      y: points[3][1],
      z: points[3][2],
    },
    annotationUID: uid,
  };
  return savingJson;
};

export const getCornerstoneLegacyJson = (data) => {
  let json = {
    measurementId: -1,
    status: "upd",
    visible: true,
    active: false,
    invalidated: false,
    color: "#3cb44b",
    handles: {
      start: {
        x: data[0][0],
        y: data[0][1],
        highlight: true,
        active: false,
      },
      end: {
        x: data[3][0],
        y: data[3][1],
        highlight: true,
        active: false,
      },
      textBox: {
        active: false,
        hasMoved: false,
        movesIndependently: false,
        drawnIndependently: true,
        allowedOutsideImage: true,
        hasBoundingBox: true,
      },
    },
    annotationId: 2,
    meanStdDev: {
      count: 8073,
      mean: 9336.438374829679,
      variance: 208541.22031359375,
      stdDev: 456.6631365827482,
    },
    area: 1419.2206782454734,
    unit: "mm²",
  };
  return json;
};

export const getTextAnnotationLegacyData = (data) => {
  let obj = {
    measurementId: -1,
    visible: true,
    active: false,
    color: "#ff0",
    handles: {
      start: {
        x: data.start[0],
        y: data.start[1],
        highlight: true,
        active: false,
      },
      end: {
        x: data.end[0],
        y: data.end[1],
        highlight: true,
        active: false,
      },
      textBox: {
        active: false,
        hasMoved: false,
        movesIndependently: false,
        drawnIndependently: true,
        allowedOutsideImage: true,
        hasBoundingBox: true,
        x: data.worldPos[0],
        y: data.worldPos[1],
        boundingBox: {
          width: data.boundingBox.width,
          height: data.boundingBox.height,
          left: data.boundingBox.left,
          top: data.boundingBox.top,
        },
      },
    },
    annotationId: -1,
    status: "upd",
    text: data.text,
    annotationUID: data.annotationUID,
    cameraFocalPoint: data.cameraFocalPoint, 
    sliceIndex: data.sliceIndex,
    cachedStats: data.cachedStats,
    arrowFirst: data.arrowFirst
  };
  return obj;
};

export const getTextAnnotation3DObject = (
  viewPlaneNormal,
  viewUp,
  frameOfReferenceUID,
  referencedImageId,
  start,
  end,
  worldPosition,
  topLeft,
  topRight,
  bottomLeft,
  bottomRight,
  text,
  annotationUID,
  cameraFocalPoint, 
  sliceIndex, 
  cachedStats,
  arrowFirst
) => {
  let obj = {
    highlighted: true,
    invalidated: true,
    metadata: {
      toolName: "ArrowAnnotate",
      viewPlaneNormal,
      viewUp,
      referencedImageId,
      frameOfReferenceUID,
      cameraFocalPoint,
      sliceIndex    
    },
    data: {
      text,
      handles: {
        points: [start, end],
        activeHandleIndex: null,
        arrowFirst,
        textBox: {
          hasMoved: false,
          worldPosition,
          worldBoundingBox: {
            topLeft,
            topRight,
            bottomLeft,
            bottomRight,
          },
        },
      },
      label: "",
      cachedStats
    },
    annotationUID,
    isLocked: false,
    isVisible: true,
  };
  return obj;
};
